import type { Column } from "@shared/types/data-table"
import type { UprdrBatch } from "@shared/types/uprdr-batch.types"
import type { ColumnManagementConfig } from "@shared/lib/tables/utils/column-management"
import {
  createStatusColumn,
  createTextColumn,
  createDateColumn,
} from "./column-factories"

export const UPRDR_BATCH_COLUMNS: Record<string, Column<UprdrBatch>> = {
  status: createStatusColumn<UprdrBatch>("uprdr-batch"),
  batchSize: createTextColumn<UprdrBatch>(
    "batchSize",
    "Batch Size",
    110,
    "tabular-nums text-muted-foreground group-hover:text-foreground",
    undefined,
    (value: unknown) => Number(value).toLocaleString()
  ),
  successRate: createTextColumn<UprdrBatch>(
    "successRate",
    "Success Rate",
    120,
    "tabular-nums text-muted-foreground group-hover:text-foreground",
    undefined,
    (value: unknown) => `${value}%`
  ),
  networks: createTextColumn<UprdrBatch>(
    "networks",
    "Networks",
    180,
    "text-muted-foreground group-hover:text-foreground truncate",
    undefined,
    (value: unknown) => (Array.isArray(value) ? value.join(', ') : String(value))
  ),
  batchCompleted: createDateColumn<UprdrBatch>("batchCompleted", "Batch Completed", 170),
  batchUpdated: createDateColumn<UprdrBatch>("batchUpdated", "Batch Updated", 170),
}

export const UPRDR_BATCH_STATUS_CONFIG = {
  all: ["status", "batchSize", "successRate", "networks", "batchCompleted", "batchUpdated"],
} as const

export const getUprdrBatchColumns = (status: string = 'all'): Column<UprdrBatch>[] => {
  const keys = UPRDR_BATCH_STATUS_CONFIG[status as keyof typeof UPRDR_BATCH_STATUS_CONFIG] || UPRDR_BATCH_STATUS_CONFIG.all
  return keys.map(key => UPRDR_BATCH_COLUMNS[key]).filter(Boolean)
}

export const getUprdrBatchColumnConfig = (status: string = 'all'): ColumnManagementConfig[] => {
  const visibleKeys: Set<string> = new Set(UPRDR_BATCH_STATUS_CONFIG[status as keyof typeof UPRDR_BATCH_STATUS_CONFIG] || UPRDR_BATCH_STATUS_CONFIG.all)
  return Object.entries(UPRDR_BATCH_COLUMNS).map(([key, col], index) => ({
    id: col.key,
    label: typeof col.header === 'string' ? col.header : col.key,
    visible: visibleKeys.has(key),
    required: ["status", "batchSize"].includes(key),
    order: index,
  }))
}
